import React from 'react';
import { useTranslation } from "react-i18next";
import { Input, Checkbox, TextArea, NumericTextBox } from '@progress/kendo-react-inputs';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { FloatingLabel } from '@progress/kendo-react-labels';
import { Button } from '@progress/kendo-react-buttons';
export default function NavesCreateComponents() {

    const { t } = useTranslation();

    const [integrador, setIntegrador] = React.useState('');
    const [activo, setActivo] = React.useState('');

    const Integradores = [
        'Baseball',
        'Basketball',
        'Volleyball'
    ];
    return (
        <div>

            <div className="container-fluid mt-4">
                <div className="col-12 col-lg-11 mx-auto">
                    <div className="card">
                        <div className="card-body bg-light py-3">
                            <h5 className="card-title m-0">{t("Global_Label_Text_General")}</h5>
                        </div>

                        <div className="container p-3 p-md-4">
                            <div className="row g-3 mb-3 mb-md-4 align-items-center">
                                <div className="col-12 col-sm-6 col-md-3">
                                    <Input
                                        label={t("Global_Label_Text_Description")}
                                        style={{ width: "80%" }}
                                    />
                                </div>

                                <div className="col-12 col-sm-6 col-md-3">
                                    <FloatingLabel label={t("Global_Label_Text_Switching_Mode")} editorId="ciudadIntegrador" editorValue={integrador}>
                                        <DropDownList
                                            id="ciudadIntegrador"
                                            style={{ width: '100%' }}
                                            data={Integradores}
                                            value={integrador}
                                            onChange={(e) => setIntegrador(e.target.value)}
                                        />
                                    </FloatingLabel>
                                </div>

                                <div className="col-12 col-sm-6 col-md-3">
                                    <NumericTextBox
                                        label={t("Global_Label_Text_Ability")}
                                        style={{ width: "100%" }}
                                        defaultValue={1000}
                                    />
                                </div>

                                <div className="col-12 col-sm-6 col-md-2">
                                    <FloatingLabel label={t("Global_Label_Text_Switching_Not_Groups_Silo")}>
                                        <Checkbox
                                            defaultChecked={false}
                                            value={activo}
                                            onChange={(e) => setActivo(e.target.value)}
                                        />
                                    </FloatingLabel>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container-fluid mt-4">
                <div className="col-12 col-lg-11 mx-auto">
                    <div className="card">
                        <div className="card-body bg-light py-3">
                            <h5 className="card-title m-0">{t("Global_Label_Text_Remarks")}</h5>
                        </div>

                        <div className="container p-3 p-md-4">
                            <div className="row justify-content-center">
                                <div className="col-12 text-center">
                                    <TextArea
                                        label={t("Global_Label_Text_Remarks")}
                                        rows={3}
                                        style={{ width: "80%" }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container-fluid mt-4">
                <div className="col-12 col-lg-11 mx-auto">
                    <div className="d-flex justify-content-end mb-3">
                        <Button className="action-button me-lg-11">{t("Global_Label_Text_Save")}</Button>
                    </div>
                </div>
            </div>

        </div>
    );
}